<!--
 * @Date: 2024-05-20 15:16:09
 * @LastEditTime: 2024-09-02 11:08:58
 * @Description: App.vue
 * @FilePath: /ql-official/src/App.vue
-->
<template>
  <div id="app" :class="[device]">
    <PcHeader v-if="device == 'pc'" />
    <MobileHeader v-else />

    <div class="page">
      <keep-alive>
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </div>

    <PcFooter v-if="device == 'pc'" />
    <MobileFooter v-else />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter /* , Action */ } from "vuex-class";

import PcHeader from "@/components/PcHeader.vue";
import PcFooter from "@/components/PcFooter.vue";
import MobileHeader from "@/components/MobileHeader.vue";
import MobileFooter from "@/components/MobileFooter.vue";
// import { throttle } from "./utils";

@Component({ components: { PcHeader, PcFooter, MobileHeader, MobileFooter } })
export default class App extends Vue {
  @Getter("app/device")
  device?: string;

  // 手机版没改版和对接接口
  // @Action("app/setDevice")
  // setDevice!: (device: string) => void;

  // resizeChange() {
  //   if (document.documentElement.clientWidth > 1000) {
  //     // 默认设置当屏幕宽度 > 1000 时，为PC端
  //     this.setDevice("pc");
  //   } else {
  //     // 默认设置当屏幕宽度 <= 1000 时，为移动端
  //     this.setDevice("mobile");
  //   }
  // }

  // created() {
  //   // resize节流
  //   this.resizeChange = throttle(this.resizeChange, 200);
  //   this.resizeChange();
  //   window.addEventListener("resize", this.resizeChange, false);
  // }

  // destroyed() {
  //   window.removeEventListener("resize", this.resizeChange, false);
  // }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh - 225px - 97px);
}
</style>
